const convertToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      // Get the base64 string with the data:image prefix
      const base64String = reader.result;
      resolve(base64String);
    };
    reader.onerror = (error) => reject(error);
  });
};

export default convertToBase64;